export const eventosOrdinariosFields = (jurosOptions) => {
    const jurosItems = (jurosOptions || []).map(juros => ({value: juros.IDJuros, label: juros.Calculo}))

    return [
        {key: "IDFluxoEvento", label: "ID FLUXO EVENTO"},
        {key: "IDEmissao", label: "ID EMISSÃO"},
        {key: "VersaoDocumento", label: "VERSÃO DOCUMENTO"},
        {key: "DataReferencia", label: "DATA REFERÊNCIA"},
        {key: "CETIP", label: "CETIP"},
        {key: "Indexador", label: "INDEXADOR"},
        {key: "ValorNominal", label: "VALOR NOMINAL"},
        {key: "LiquidezDiaria", label: "LIQUIDEZ DIÁRIA"},
        {key: "IndexadorCorrecaoPercentual", label: "INDEXADOR CORREÇÃO PERCENTUAL"},
        {key: "Defasagem", label: "DEFASAGEM"},
        {
            key: "FormulaIndexador",
            label: "FÓRMULA INDEXADOR",
            type: "select",
            options: jurosItems
        },
        {key: "CalculoDiasIndexador", label: "CALCULO DIAS INDEXADOR"},
        {key: "PeriodicidadeAtualizacaoMonetaria", label: "PERIODICIDADE ATUALIZAÇÃO MONETÁRIA"},
        {key: "MesAniversarioAnualSemestral", label: "MÊS ANIVERSÁRIO ANUAL SEMESTRAL"},
        {key: "ProjecaoInflacao", label: "PROJEÇÃO INFLAÇÃO"},
        {key: "InflacaoNegativa", label: "INFLAÇÃO NEGATIVA"},
        {key: "RecalculoProjecao", label: "RECALCULO PROJEÇÃO"},
        {key: "DataEvento", label: "DATA EVENTO"},
        {key: "DataEventoEfetiva", label: "DATA EVENTO EFETIVA"},
        {key: "DataAniversarioJuros", label: "DATA ANIVERSÁRIO JUROS"},
        {key: "DataLiquidacao", label: "DATA LIQUIDAÇÃO"},
        {key: "AplicacaoAmortizacao", label: "APLICAÇÃO AMORTIZAÇÃO"},
        {key: "AmortizacaoOrdinariaPercentual", label: "AMORTIZAÇÃO ORDINÁRIA PERCENTUAL"},
        {key: "TaxaJuros", label: "TAXA JUROS"},
        {
            key: "JurosCapitalizacao",
            label: "JUROS CAPITALIZAÇÃO",
            type: "select",
            options: jurosItems
        },
        {key: "CalculoDias", label: "CÁLCULO DIAS"},
        {key: "JurosIncorporacaoProgramadaPercentual", label: "JUROS INCORPORAÇÃO PROGRAMADA PERCENTUAL"},
        {key: "DataRentabilidadeInicio", label: "DATA RENTABILIDADE INÍCIO"},
        {key: "DataRentabilidadeFim", label: "DATA RENTABILIDADE FIM"},
        {key: "CalculoFatorJuros", label: "CÁLCULO FATOR JUROS"},
        {key: "CasasFatorJuros", label: "CASAS FATOR JUROS"},
        {key: "CalculoJuros", label: "CÁLCULO JUROS"},
        {key: "CasasJuros", label: "CASAS JUROS"},
        {key: "CalculoFatorCorrecao", label: "CÁLCULO FATOR CORREÇÃO"},
        {key: "CasasFatorCorrecao", label: "CASAS FATOR CORREÇÃO"},
        {key: "CalculoCorrecao", label: "CÁLCULO CORREÇÃO"},
        {key: "CasasCorrecao", label: "CASAS CORREÇÃO"},
        {key: "CalculoFatorJurosCDI", label: "CÁLCULO FATOR JUROS CDI"},
        {key: "CasasFatorJurosCDI", label: "CASAS FATOR JUROS CDI"},
        {key: "CalculoVNA", label: "CÁLCULO VNA"},
        {key: "CasasVNA", label: "CASAS VNA"},
        {key: "CalculoFatorDesconto", label: "CÁLCULO FATOR DESCONTO"},
        {key: "CasasFatorDesconto", label: "CASAS FATOR DESCONTO"},
        {key: "CalculoFatorExpectativa", label: "CÁLCULO FATOR EXPECTATIVA"},
        {key: "CasasFatorExpectativa", label: "CASAS FATOR EXPECTATIVA"},
        {key: "CalculoPU", label: "CÁLCULO PU"},
        {key: "CasasPU", label: "CASAS PU"},
        {key: "Observacao", label: "OBSERVAÇÃO"},
    ]
}